












import {
  DynamicDocumentItem,
  DynamicDocumentItemData,
  InstallationModuleData,
  Material
} from "@/types";

import SerialnumberGrid from "@/components/SerialNumberGrid";

import Vue, { PropType, VueConstructor } from "vue";

export default Vue.extend({
  components: {
    SerialnumberGrid
  },

  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>
  },

  computed: {
    inverters(): Material[] {
      return this.$store.state.materials.inverters.items;
    },

    patterns(): string[] {
      return this.inverters.flatMap(inverter => inverter.patterns ?? []).filter(Boolean);
    }
  }
});
